import { version, productName } from '../../package.json'

export default async ({ Vue }) => {
  Vue.prototype.version = version
  Vue.prototype.productName = productName
}
